import { DATA_CENTER_ACTIONS, FILE_HISTORY_ACTIONS, DATA_CENTER_FILE_REQUEST, DATA_CENTER_FILE_HEADERS, FILE_RECORDS_ACTIONS } from "../actions/DataCenterActionTypes";

const initialState = () => ({
    dataCenter: {
        currentRecord: null,
        list: [],
        createReqStatus: null,
        listReqStatus: null,
        totalRows: 0,
    },
    fileHistory: {
        fileHistory: [],
        totalRows: 0,
        loading: false,
        error: false,
    },
    fileUpload: {
        loading: false,
        error: false,
        response: null,
    },
    fileHeaders: {
        data: [],
        loading: false,
        error: false,
    },
    fileRecords: {
        data: [],
        columns: [],
        loading: false,
        error: null,
        headerId: null,
        totalRecords: 0,
        dataCenterId: null
    },
});

export default (state = initialState(), action) => {
    switch (action.type) {
        case DATA_CENTER_ACTIONS.DATA_CENTER_CREATE: {
            return {
                ...state,
                dataCenter: {
                    ...state.dataCenter,
                    createReqStatus: 'PENDING',
                },
            };
        }
        case DATA_CENTER_ACTIONS.DATA_CENTER_CREATE_SUCCESS: {
            return {
                ...state,
                dataCenter: {
                    ...state.dataCenter,
                    currentRecord: action.data,
                    createReqStatus: 'SUCCESS',
                },
            };
        }
        case DATA_CENTER_ACTIONS.DATA_CENTER_CREATE_ERROR: {
            return {
                ...state,
                dataCenter: {
                    ...state.dataCenter,
                    createReqStatus: 'ERROR',
                },
            };
        }
        case DATA_CENTER_ACTIONS.DATA_CENTER_LIST: {
            return {
                ...state,
                dataCenter: {
                    ...state.dataCenter,
                    listReqStatus: 'PENDING',
                },
            };
        }
        case DATA_CENTER_ACTIONS.DATA_CENTER_LIST_SUCCESS: {
            return {
                ...state,
                dataCenter: {
                    ...state.dataCenter,
                    list: action.data,
                    totalRows: action.totalRows,
                    listReqStatus: 'SUCCESS',
                },
            };
        }
        case DATA_CENTER_ACTIONS.DATA_CENTER_LIST_ERROR: {
            return {
                ...state,
                dataCenter: {
                    ...state.dataCenter,
                    listReqStatus: 'ERROR',
                },
            };
        }
        case FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_REQUEST: {
            return {
                ...state,
                fileHistory: {
                    ...state.fileHistory,
                    loading: true,
                    error: false,
                },
            };
        }
        case FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_SUCCESS: {
            console.log('acion', action.payload)
            return {
                ...state,
                fileHistory: {
                    ...state.fileHistory,
                    fileHistory: action.payload.data,
                    // totalRows: action.payload.totalRows,
                    loading: false,
                },
            };
        }
        case FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_ERROR: {
            return {
                ...state,
                fileHistory: {
                    ...state.fileHistory,
                    loading: false,
                    error: true,
                },
            };
        }
        case DATA_CENTER_FILE_REQUEST.FILE_UPLOAD_REQUEST: {
            return {
                ...state,
                fileUpload: {
                    ...state.fileUpload,
                    loading: true,
                    error: false,
                },
            };
        }
        case DATA_CENTER_FILE_REQUEST.FILE_UPLOAD_SUCCESS: {
            return {
                ...state,
                fileUpload: {
                    ...state.fileUpload,
                    response: action.payload,
                    loading: false,
                },
            };
        }
        case DATA_CENTER_FILE_REQUEST.FILE_UPLOAD_ERROR: {
            return {
                ...state,
                fileUpload: {
                    ...state.fileUpload,
                    loading: false,
                    error: true,
                },
            };
        }
        case DATA_CENTER_FILE_HEADERS.FILE_HEADERS_REQUEST: {
            return {
                ...state,
                fileHeaders: {
                    ...state.fileHeaders,
                    loading: true,
                    error: false,
                },
            };
        }
        case DATA_CENTER_FILE_HEADERS.FILE_HEADERS_SUCCESS: {
            return {
                ...state,
                fileHeaders: {
                    ...state.fileHeaders,
                    data: action.payload,
                    loading: false,
                },
            };
        }
        case DATA_CENTER_FILE_HEADERS.FILE_HEADERS_ERROR: {
            return {
                ...state,
                fileHeaders: {
                    ...state.fileHeaders,
                    loading: false,
                    error: true,
                },
            };
        }
        case DATA_CENTER_FILE_HEADERS.ADD_COLUMN: {
            const newColumn = {
                order: state.fileHeaders?.data?.length + 1,
                fieldName: `Column_${state.fileHeaders?.data?.length + 1}`,
                headerValue: `Column_${state.fileHeaders?.data?.length + 1}`,
                isUid: false
            };
            return {
                ...state,
                fileHeaders: {
                    ...state.fileHeaders,
                    data: [...state.fileHeaders?.data, newColumn],
                    loading: false,
                    error: true,
                },
            };
        }
        case DATA_CENTER_FILE_HEADERS.REMOVE_COLUMN: {
            return {
                ...state,

                fileHeaders: {
                    ...state.fileHeaders,
                    data: state?.fileHeaders?.data?.filter((column, index) => index !== action.payload),
                    loading: false,
                    error: true,
                },
            };
        }
        case FILE_RECORDS_ACTIONS.FILE_RECORDS_REQUEST: {
            return {
                ...state,
                fileRecords: {
                    ...state.fileRecords,
                    loading: true,
                    error: null,
                    headerId: null,
                },
            };
        }
        case FILE_RECORDS_ACTIONS.FILE_RECORDS_SUCCESS: {
            const isFirstPage = action.payload?.currentPage === 1;

            return {
                ...state,
                fileRecords: {
                    ...state.fileRecords,
                    data: isFirstPage
                        ? action.payload?.data
                        : [...state.fileRecords.data, ...action.payload?.data],
                    columns: action.payload?.columns,
                    loading: false,
                    headerId: action.payload?.headerId,
                    totalRecords: action.payload?.totalRecords
                },
            };
        }
        case FILE_RECORDS_ACTIONS.UPDATE_DATA_CENTER_ID: {
            return {
                ...state,
                fileRecords: {
                    ...state.fileRecords,
                    dataCenterId: action.payload,
                    data: [],
                    columns: [],
                    loading: false,
                    error: null,
                    headerId: null,
                    totalRecords: 0,
                },
            };
        }
        case FILE_RECORDS_ACTIONS.FILE_RECORDS_ERROR: {
            return {
                ...state,
                fileRecords: {
                    ...state.fileRecords,
                    loading: false,
                    error: action.payload,
                    headerId: null,
                    // totalRecords: 0
                },
            };
        }
        case DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN_VISIBILITY_SUCCESS:
            return {
                ...state,
                fileRecords: {
                    ...state.fileRecords,
                    columns: action.payload,
                }
            };

        case DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN:
            console.log(action.payload)
            return {
                ...state,
                fileHeaders: {
                    ...state.fileHeaders,
                    data: state?.fileHeaders?.data.map((column, index) => {
                        if (column.fieldName === action.payload?.fieldName) {
                            return {
                                ...column,
                                headerValue: action.payload?.headerValue,
                            };
                        }
                        return column;
                    }),
                },
            };

        case DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN_VISIBILITY_ERROR:
            return {
                ...state,
                fileRecords: {
                    ...state.fileRecords,
                    error: action.payload,
                }
            };
        default:
            return state;
    }
};